import { render, staticRenderFns } from "./ProjectDetailsHeader.vue?vue&type=template&id=e99dd9dc&scoped=true&"
import script from "./ProjectDetailsHeader.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsHeader.vue?vue&type=style&index=0&id=e99dd9dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99dd9dc",
  null
  
)

export default component.exports